'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _Object$keys = require('@babel/runtime-corejs3/core-js-stable/object/keys');
var _Object$getOwnPropertySymbols = require('@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols');
var _filterInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/filter');
var _Object$getOwnPropertyDescriptor = require('@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor');
var _Object$getOwnPropertyDescriptors = require('@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors');
var _extends = require('@babel/runtime-corejs3/helpers/extends');
var _defineProperty = require('@babel/runtime-corejs3/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime-corejs3/helpers/objectWithoutProperties');
var _concatInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/concat');
var _Object$freeze = require('@babel/runtime-corejs3/core-js-stable/object/freeze');
var React = require('react');
var button = require('baseui/button');
var baseui = require('baseui');
var inlineStyleExpandShorthand = require('inline-style-expand-shorthand');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _Object$keys__default = /*#__PURE__*/_interopDefaultLegacy(_Object$keys);
var _Object$getOwnPropertySymbols__default = /*#__PURE__*/_interopDefaultLegacy(_Object$getOwnPropertySymbols);
var _filterInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_filterInstanceProperty);
var _Object$getOwnPropertyDescriptor__default = /*#__PURE__*/_interopDefaultLegacy(_Object$getOwnPropertyDescriptor);
var _Object$getOwnPropertyDescriptors__default = /*#__PURE__*/_interopDefaultLegacy(_Object$getOwnPropertyDescriptors);
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _concatInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_concatInstanceProperty);
var _Object$freeze__default = /*#__PURE__*/_interopDefaultLegacy(_Object$freeze);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _excluded = ["overrides", "isDestructive", "isText", "borderLess"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys__default["default"](object); if (_Object$getOwnPropertySymbols__default["default"]) { var symbols = _Object$getOwnPropertySymbols__default["default"](object); enumerableOnly && (symbols = _filterInstanceProperty__default["default"](symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor__default["default"](object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : _Object$getOwnPropertyDescriptors__default["default"] ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors__default["default"](source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor__default["default"](source, key)); }); } return target; }
var Button = /*#__PURE__*/React__default["default"].forwardRef(function (props, ref) {
  var overrides = props.overrides,
      isDestructive = props.isDestructive,
      isText = props.isText,
      borderLess = props.borderLess,
      rest = _objectWithoutProperties__default["default"](props, _excluded);

  var buttonOverrides = {
    BaseButton: {
      style: function style(_ref) {
        var $theme = _ref.$theme,
            $kind = _ref.$kind,
            $shape = _ref.$shape,
            $isLoading = _ref.$isLoading,
            $isSelected = _ref.$isSelected,
            $size = _ref.$size,
            $disabled = _ref.$disabled;
        return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
          boxShadow: 'none',
          ':focus-visible': {
            outline: "3px solid ".concat($theme.colors.outline)
          }
        }, getFontStyles({
          $theme: $theme,
          $size: $size
        })), {}, {
          letterSpacing: '0.02em'
        }, getPaddingStyles({
          $theme: $theme,
          $size: $size,
          $shape: $shape,
          $isSelected: $isSelected,
          $kind: $kind,
          $isDestructive: isDestructive,
          $isText: isText,
          $borderLess: borderLess || false
        })), getBorderRadiiStyles({
          $theme: $theme,
          $size: $size,
          $shape: $shape,
          $isText: isText
        })), getKindStyles({
          $theme: $theme,
          $kind: $kind,
          $isLoading: $isLoading,
          $isSelected: $isSelected,
          $disabled: $disabled,
          $shape: $shape,
          $isDestructive: isDestructive,
          $isText: isText,
          $borderLess: borderLess || false
        })), getShapeStyles({
          $shape: $shape,
          $size: $size
        }));
      }
    },
    LoadingSpinner: {
      style: function style(_ref2) {
        var $theme = _ref2.$theme,
            $kind = _ref2.$kind,
            $isSelected = _ref2.$isSelected,
            $shape = _ref2.$shape,
            $size = _ref2.$size,
            $isLoading = _ref2.$isLoading,
            $disabled = _ref2.$disabled;
        return _objectSpread({}, getLoadingStyles({
          $theme: $theme,
          $kind: $kind,
          $isLoading: $isLoading
        }));
      }
    },
    LoadingSpinnerContainer: {
      style: function style(_ref3) {
        var $theme = _ref3.$theme,
            $size = _ref3.$size;
        return {
          marginTop: '5px',
          marginBottom: '5px'
        };
      }
    },
    StartEnhancer: {
      style: function style(_ref4) {
        var $theme = _ref4.$theme,
            $kind = _ref4.$kind,
            $isSelected = _ref4.$isSelected,
            $shape = _ref4.$shape,
            $size = _ref4.$size,
            $isLoading = _ref4.$isLoading,
            $disabled = _ref4.$disabled;
        return _objectSpread({}, getEnhancerStyles({
          $theme: $theme,
          $size: $size,
          isStart: true
        }));
      }
    },
    EndEnhancer: {
      style: function style(_ref5) {
        var $theme = _ref5.$theme,
            $kind = _ref5.$kind,
            $isSelected = _ref5.$isSelected,
            $shape = _ref5.$shape,
            $size = _ref5.$size,
            $isLoading = _ref5.$isLoading,
            $disabled = _ref5.$disabled;
        return _objectSpread({}, getEnhancerStyles({
          $theme: $theme,
          $size: $size,
          isStart: false
        }));
      }
    }
  };
  return /*#__PURE__*/React__default["default"].createElement(button.Button, _extends__default["default"]({}, rest, {
    overrides: baseui.mergeOverrides(buttonOverrides, overrides),
    ref: ref
  }));
});

function getFontStyles(_ref6) {
  var $theme = _ref6.$theme,
      $size = _ref6.$size;

  switch ($size) {
    case button.SIZE.mini:
      return {
        fontSize: '10px',
        lineHeight: '14px',
        fontWeight: 'normal'
      };

    case button.SIZE.compact:
      return {
        fontSize: '12px',
        lineHeight: '18px',
        fontWeight: 'normal'
      };

    case button.SIZE.large:
      return {
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: 500
      };

    default:
      return {
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: 600
      };
  }
}

function getPaddingStyles(_ref7) {
  var $theme = _ref7.$theme,
      $size = _ref7.$size,
      $shape = _ref7.$shape,
      $isSelected = _ref7.$isSelected,
      $kind = _ref7.$kind,
      $isDestructive = _ref7.$isDestructive,
      $isText = _ref7.$isText,
      $borderLess = _ref7.$borderLess;

  if ($borderLess) {
    return {
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paddingBottom: 0
    };
  }

  var iconShape = $shape === button.SHAPE.square || $shape === button.SHAPE.circle || $shape === button.SHAPE.round || $isText;

  switch ($size) {
    case button.SIZE.mini:
      return {
        paddingTop: '3px',
        paddingBottom: '3px',
        paddingLeft: iconShape ? '3px' : '6px',
        paddingRight: iconShape ? '3px' : '6px'
      };

    case button.SIZE.compact:
      return {
        paddingTop: '3px',
        paddingBottom: '3px',
        paddingLeft: iconShape ? '3px' : '11px',
        paddingRight: iconShape ? '3px' : '11px'
      };

    case button.SIZE.large:
      return {
        paddingTop: '13px',
        paddingBottom: '13px',
        paddingLeft: iconShape ? '13px' : '24px',
        paddingRight: iconShape ? '13px' : '24px'
      };

    default:
      // for destructive button
      if ($isDestructive || iconShape) {
        return {
          paddingTop: '7px',
          paddingBottom: '7px',
          paddingLeft: iconShape ? '7px' : '15px',
          paddingRight: iconShape ? '7px' : '15px'
        };
      }

      return {
        paddingTop: '6px',
        paddingBottom: '6px',
        paddingLeft: '14px',
        paddingRight: '14px'
      };
  }
}

function getBorderRadiiStyles(_ref8) {
  var $theme = _ref8.$theme,
      $size = _ref8.$size,
      $shape = _ref8.$shape;
  var value = $theme.borders.buttonBorderRadius;

  if ($shape === button.SHAPE.pill) {
    if ($size === button.SIZE.compact) {
      value = '15px';
    } else if ($size === button.SIZE.large) {
      value = '21px';
    } else {
      value = '17px';
    }
  } else if ($shape === button.SHAPE.circle || $shape === button.SHAPE.round) {
    value = '50%';
  } else if ($shape === button.SHAPE.default || $shape === button.SHAPE.square) {
    if ($size === button.SIZE.large) {
      value = '5px';
    } else {
      value = '5px';
    }
  }

  return {
    borderTopRightRadius: value,
    borderBottomRightRadius: value,
    borderTopLeftRadius: value,
    borderBottomLeftRadius: value
  };
}

// treat selected the same as active
function getKindStyles(_ref9) {
  var _context2, _context4, _context6;

  var $theme = _ref9.$theme,
      $isLoading = _ref9.$isLoading,
      $isSelected = _ref9.$isSelected,
      $kind = _ref9.$kind,
      $disabled = _ref9.$disabled,
      $shape = _ref9.$shape,
      $isDestructive = _ref9.$isDestructive,
      $isText = _ref9.$isText,
      $borderLess = _ref9.$borderLess;
  var theme = $theme;
  var iconShape = $shape === button.SHAPE.square || $shape === button.SHAPE.circle || $shape === button.SHAPE.round;

  if ($disabled) {
    return {
      ':disabled': _objectSpread({
        color: $isText || $borderLess ? theme.colors.gray400 : '#FFFFFE',
        backgroundColor: $isText || $borderLess ? 'transparent' : theme.colors.gray200
      }, inlineStyleExpandShorthand.expand({
        border: "".concat($borderLess ? 0 : $isDestructive || iconShape || $isText ? 1 : 2, "px solid transparent")
      }))
    };
  }

  if ($isText) {
    if ($isSelected) {
      return _objectSpread({
        color: theme.colors.secondary900,
        backgroundColor: 'transparent'
      }, inlineStyleExpandShorthand.expand({
        border: "1px solid ".concat(theme.colors.information)
      }));
    }

    return _objectSpread(_objectSpread({
      color: theme.colors.secondary800,
      backgroundColor: 'transparent'
    }, inlineStyleExpandShorthand.expand({
      border: "1px solid transparent"
    })), {}, {
      ':hover': {
        color: theme.colors.secondary900,
        backgroundColor: 'transparent'
      },
      ':active': _objectSpread({
        backgroundColor: 'transparent'
      }, inlineStyleExpandShorthand.expand({
        border: "1px solid ".concat(theme.colors.information)
      }))
    });
  }

  switch ($kind) {
    case button.KIND.primary:
      if ($isSelected) {
        var _context;

        return _objectSpread({
          color: theme.colors.black01,
          backgroundColor: theme.colors.primary1000,
          boxShadow: '0px 4px 6px rgba(211, 120, 40, 0.3)'
        }, inlineStyleExpandShorthand.expand({
          border: _concatInstanceProperty__default["default"](_context = "".concat(iconShape ? 1 : 2, "px solid ")).call(_context, theme.colors.primary)
        }));
      }

      return _objectSpread(_objectSpread({
        color: theme.colors.black01,
        backgroundColor: theme.colors.primaryAction
      }, inlineStyleExpandShorthand.expand({
        border: "".concat(iconShape ? 1 : 2, "px solid transparent")
      })), {}, {
        ':hover': {
          backgroundColor: theme.colors.primary900,
          boxShadow: '0px 4px 6px rgba(211, 120, 40, 0.3)'
        },
        ':active': _objectSpread({
          backgroundColor: theme.colors.primary1000,
          boxShadow: '0px 4px 6px rgba(211, 120, 40, 0.3)'
        }, inlineStyleExpandShorthand.expand({
          border: _concatInstanceProperty__default["default"](_context2 = "".concat(iconShape ? 1 : 2, "px solid ")).call(_context2, theme.colors.primary)
        }))
      });

    case button.KIND.secondary:
      if ($isSelected) {
        var _context3;

        return _objectSpread({
          color: $isDestructive ? theme.colors.error : theme.colors.black01,
          backgroundColor: theme.colors.primary600,
          boxShadow: $isDestructive ? 'none' : '0px 4px 6px rgba(211, 120, 40, 0.3)'
        }, inlineStyleExpandShorthand.expand({
          border: $isDestructive ? "1px solid ".concat(theme.colors.error) : _concatInstanceProperty__default["default"](_context3 = "".concat(iconShape ? 1 : 2, "px solid ")).call(_context3, theme.colors.primary800)
        }));
      }

      return _objectSpread(_objectSpread({
        color: $isDestructive ? theme.colors.error : theme.colors.black01,
        backgroundColor: '#fff'
      }, inlineStyleExpandShorthand.expand({
        border: _concatInstanceProperty__default["default"](_context4 = "".concat($isDestructive || iconShape ? 1 : 2, "px solid ")).call(_context4, $isDestructive ? theme.colors.error : theme.colors.primary)
      })), {}, {
        ':hover': {
          boxShadow: $isDestructive ? 'none' : '0px 4px 6px rgba(211, 120, 40, 0.3)',
          backgroundColor: theme.colors.primary300
        },
        ':active': {
          boxShadow: $isDestructive ? 'none' : '0px 4px 6px rgba(211, 120, 40, 0.3)',
          backgroundColor: theme.colors.primary600
        }
      });

    case button.KIND.tertiary:
      if ($isSelected) {
        var _context5;

        return _objectSpread({
          color: theme.colors.black01,
          backgroundColor: $borderLess ? 'transparent' : '#D4DADF',
          boxShadow: iconShape || $borderLess ? 'none' : '0px 4px 6px rgba(170, 181, 191, 0.3)'
        }, inlineStyleExpandShorthand.expand({
          border: _concatInstanceProperty__default["default"](_context5 = "".concat(iconShape ? 1 : 2, "px solid ")).call(_context5, $borderLess ? 'transparent' : theme.colors.gray400)
        }));
      }

      return _objectSpread(_objectSpread({
        color: iconShape || $borderLess ? '#3F5870' : theme.colors.black01,
        // for borderLess, no border, and background is transparent
        backgroundColor: $borderLess ? 'transparent' : '#fff'
      }, inlineStyleExpandShorthand.expand({
        border: _concatInstanceProperty__default["default"](_context6 = "".concat($borderLess ? 0 : iconShape ? 1 : 2, "px solid ")).call(_context6, $borderLess ? 'transparent' : theme.colors.gray400)
      })), {}, {
        ':hover': {
          boxShadow: iconShape || $borderLess ? 'none' : '0px 4px 6px rgba(170, 181, 191, 0.3)',
          backgroundColor: theme.colors.gray50
        },
        ':active': {
          boxShadow: iconShape || $borderLess ? 'none' : '0px 4px 6px rgba(170, 181, 191, 0.3)',
          backgroundColor: theme.colors.gray200
        }
      });

    default:
      return _Object$freeze__default["default"]({});
  }
}

function getLoadingStyles(_ref10) {
  var $theme = _ref10.$theme,
      $isLoading = _ref10.$isLoading,
      $kind = _ref10.$kind;

  if (!$isLoading) {
    return {};
  }

  var theme = $theme;

  if ($kind === button.KIND.primary) {
    return {
      borderTopColor: '#fff',
      borderLeftColor: '#fff',
      borderBottomColor: 'transparent',
      borderRightColor: 'transparent'
    };
  }

  if ($kind === button.KIND.secondary) {
    return {
      borderTopColor: theme.colors.primary,
      borderLeftColor: theme.colors.primary,
      borderBottomColor: 'transparent',
      borderRightColor: 'transparent'
    };
  }

  return {
    borderTopColor: theme.colors.gray400,
    borderLeftColor: theme.colors.gray400,
    borderBottomColor: 'transparent',
    borderRightColor: 'transparent'
  };
}

function getEnhancerStyles(_ref11) {
  var $theme = _ref11.$theme,
      $size = _ref11.$size,
      isStart = _ref11.isStart;

  switch ($size) {
    case button.SIZE.large:
      return isStart ? {
        marginRight: '14px'
      } : {
        marginLeft: '14px'
      };

    case button.SIZE.default:
      return isStart ? {
        marginRight: '8px'
      } : {
        marginLeft: '8px'
      };

    case button.SIZE.compact:
      return isStart ? {
        marginRight: '10px'
      } : {
        marginLeft: '10px'
      };

    default:
      return isStart ? {
        marginRight: '4px'
      } : {
        marginLeft: '4px'
      };
  }
}

function getShapeStyles(_ref12) {
  var $shape = _ref12.$shape,
      $size = _ref12.$size;

  if ($shape === button.SHAPE.circle || $shape === button.SHAPE.square) {
    var height, width;

    switch ($size) {
      case button.SIZE.mini:
        height = '16px';
        width = '16px';
        break;

      case button.SIZE.compact:
        height = '24px';
        width = '24px';
        break;

      case button.SIZE.large:
        height = '48px';
        width = '48px';
        break;

      case button.SIZE.default:
      default:
        height = '32px';
        width = '32px';
        break;
    }

    return {
      height: height,
      width: width,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    };
  } else {
    return {};
  }
}

exports.Button = Button;
